module.exports = __webpack_public_path__ + "static/media/professional-teaching-banner2.8f45f76d.png";